<template>
  <div>
    <ts-card class="m-t-10">
      <ts-card-wrapper>
        <div class="d-flex justify-content-end">
          <div class="d-flex">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px;"
              class="inline-block"
            />
            <ts-button
              outline
              class="ml-2"
              v-tooltip="$t('filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
        </div>
        <!-- drawer -->
        <a-drawer
          :title="$t('filter')"
          placement="right"
          :closable="false"
          :visible="visible"
          @close="onCloseDrawer"
          :zIndex="1020"
          width="300px"
        >
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="ts-text-xs">{{ $t('homePage.dateRange') }}</label>
                <a-range-picker
                  format="DD-MM-YYYY"
                  :defaultValue="rangeDate"
                  :defaultPickerValue="rangeDate"
                  @change="dateRangeChange"
                >
                  <template slot="renderExtraFooter"></template>
                </a-range-picker>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="ts-text-xs">{{ $t('homePage.branch') }}</label>
                <ts-branch-filter @filter="value => (branch_id = value)" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="ts-text-xs">{{ $t('homePage.className') }}</label>
                <treeselect
                  :load-options="loadAcademicClassesOptions"
                  :options="academicClassesOptions"
                  :placeholder="$t('all')"
                  :multiple="true"
                  :limit="1"
                  v-model="class_id"
                  @input="fetchData"
                />
              </div>
            </div>
          </div>
        </a-drawer>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :rowGroup="{
            field: 'full_student_name'
          }"
        >
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">{{ record.branch_name_en }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.invoice_date }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.invoice_number }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.fee_name_en }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.fee_type_name }}</td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ Math.round(record.discount_amount, 2) }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ Math.round(record.vat_amount, 2) }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ Math.round(record.total_amount, 2) }}
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { LOAD_ROOT_OPTIONS } from '@riophae/vue-treeselect'
import { mapState, mapActions } from 'vuex'
import { debounce } from 'lodash'
import moment from 'moment'

export default {
  name: 'paymentHistory',
  data() {
    return {
      loading: false,
      visible: false,
      branch_id: '',
      academicClassesOptions: null,
      rangeDate: [moment().add(-1, 'Month'), moment()]
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('home/paymentHistory', ['resources', 'pagination', 'classes']),
    search: {
      get() {
        return this.$store.state.home.paymentHistory.search
      },
      set(newVal) {
        this.$store.commit('home/paymentHistory/SET_SEARCH', newVal)
        this.$store.commit('home/paymentHistory/RESET_CURRENT_PAGE')
      }
    },
    class_id: {
      get() {
        return this.$store.state.home.paymentHistory.class_id
      },
      set(newVal) {
        this.$store.commit('home/paymentHistory/SET_CLASS_ID', newVal)
      }
    },
    columns() {
      return [
        { name: this.$t('homePage.branch') },
        { name: this.$t('homePage.invoiceDate') },
        { name: this.$t('homePage.invoiceNumber') },
        { name: this.$t('homePage.feeName') },
        { name: this.$t('homePage.feeTypeName') },
        { name: this.$t('homePage.discount'), style: 'text-align: center' },
        { name: this.$t('homePage.vat'), style: 'text-align: center' },
        { name: this.$t('homePage.totalAmount'), style: 'text-align: center' }
      ]
    }
  },
  methods: {
    ...mapActions('home/paymentHistory', ['fetchClasses']),
    onCloseDrawer() {
      this.visible = false
    },
    fetchData(attributes) {
      this.loading = true

      this.$store
        .dispatch('home/paymentHistory/fetch', attributes)
        .then(() => (this.loading = false))
        .catch(() => {
          this.loading = false
        })
    },
    async loadAcademicClassesOptions({ action /*, callback*/ }) {
      if (action === LOAD_ROOT_OPTIONS) {
        this.academicClassesOptions = null
        let response = await this.fetchClasses()
        if (response != undefined || response != null) {
          this.academicClassesOptions = response.data.map(el => ({
            id: el.class_id,
            label: el.class_name
          }))
        }
      }
    },
    dateRangeChange(dateRange) {
      this.$store.commit(
        'home/paymentHistory/SET_DATE_FROM',
        dateRange[0].format('DD-MM-YYYY')
      )
      this.$store.commit(
        'home/paymentHistory/SET_DATE_TO',
        dateRange[1].format('DD-MM-YYYY')
      )
      this.fetchData()
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500),
    branch_id: debounce(function(value) {
      this.fetchData({ branch_id: value })
    }, 500)
  }
}
</script>
